import { Controller } from "@hotwired/stimulus"
import { initializeTomSelect } from "../src/tom_select"

export default class extends Controller {
  static values = {
    options: Object,
    autoSubmit: Boolean
  }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) { return }

    this.originalValue = this.element.value
    this.selectedValue = this.element.value

    this.select = initializeTomSelect(this.element, {
      ...this.optionsValue,
      onChange: function(value) { this.handleChange(value) }.bind(this),
      onBlur: function() { this.handleBlur() }.bind(this)
    })
  }

  disconnect() { this.select?.destroy() }

  handleChange(value) {
    if (!value) { return }

    this.selectedValue = value
    this.select.blur()
  }

  handleBlur() {
    // Ensure the display reverts to the original value if the input was cleared and then nothing was selected.
    this.select.setValue(this.selectedValue, true)

    if (this.shouldAutoSubmit && this.selectionHasChanged()) { this.form.requestSubmit() }
  }

  selectionHasChanged() { return this.originalValue != this.selectedValue }

  get form() { return this.element.closest("form") }
  get shouldAutoSubmit() { return !!this.autoSubmitValue }
}
